import React from "react";
import { freeExams } from "../helpers/exam-dates";

type NewType = {
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
  registered: boolean;
  emailConfirmed: boolean;
  registeredUntil?: string;
  referrer: string | null;
  exam: string;
  exams: ExamRegistration[];
  checkedIfUserLoggedIn: boolean;
};

type ExamRegistration = {
  exam: string;
  registeredUntil: string;
};
// import { ICredentials} from "aws-amplify"

export interface ICredentials {
  attributes: NewType;
}

interface IContextProps {
  userState: ICredentials;
  setStateUserState: React.Dispatch<React.SetStateAction<ICredentials>>;
  isRegisteredForCurrentExam: () => boolean;
}

const UserContext = React.createContext<IContextProps>({} as IContextProps);

function useUserContext() {
  const context = React.useContext(UserContext);
  if (!context) {
    throw new Error(`userContext must be used within a UserProvider`);
  }
  return context;
}

const unauthState = () => ({
  attributes: {
    email: "",
    firstName: "",
    lastName: "",
    roles: [],
    registered: false,
    registeredUntil: "",
    emailConfirmed: false,
    referrer: null,
    exam: "",
    exams: [],
    checkedIfUserLoggedIn: false
  }
});

// Helper function to check if user is registered for the current exam
const isUserRegisteredForExam = (userState: ICredentials): boolean => {
  // Find the expiration date for the current exam
  const expirationDate = userState.attributes.exams.find(
    exam => exam.exam === userState.attributes.exam
  )?.registeredUntil;

  // If no expiration date found or exam is free, handle accordingly
  if (!expirationDate) {
    return freeExams.includes(userState.attributes.exam);
  }

  // Ensure proper ISO format with uppercase Z for UTC
  const currentExamDate = expirationDate.endsWith("z")
    ? expirationDate.slice(0, -1) + "Z"
    : expirationDate.endsWith("Z")
    ? expirationDate
    : expirationDate + "Z";

  console.log("currentExamDate", currentExamDate);
  console.log("new Date(currentExamDate)", new Date(currentExamDate));

  return (
    new Date(currentExamDate) > new Date() ||
    freeExams.includes(userState.attributes.exam)
  );
};

const isUserInFreeExam = (userState: ICredentials): boolean => {
  return freeExams.includes(userState.attributes.exam);
};

function UserProvider(props: any) {
  const [userState, setStateUserState] = React.useState<ICredentials>(
    unauthState()
  );

  const isRegisteredForCurrentExam = () => {
    return isUserRegisteredForExam(userState);
  };

  const value = React.useMemo<IContextProps>(
    () => ({ userState, setStateUserState, isRegisteredForCurrentExam }),
    [userState, setStateUserState]
  );

  return <UserContext.Provider value={value} {...props} />;
}
export {
  UserProvider,
  unauthState,
  useUserContext,
  isUserRegisteredForExam,
  isUserInFreeExam
};
